import statusLabel from './statusLabel'

const accounts = {
  statusLabel,
}

export default accounts
